import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageProviderProps {
    children: React.ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
    const { i18n } = useTranslation();

    useEffect(() => {
        // Set document direction based on language
        const dir = i18n.language.startsWith('ar') ? 'rtl' : 'ltr';
        document.documentElement.dir = dir;
        document.documentElement.lang = i18n.language;
    }, [i18n.language]);

    return <>{children}</>;
};
